<div id="tabs-wrapper">
    <div class="tab-header-section justify-content-between px-2">
        <div class="d-flex align-items-center">   
            <!-- Tab Menus -->
            <div class="task-bank-tabs">
                <span class="task-bank-header">Task Bank |</span>
                @if(taskInfoService.activeIndex.label === tabName.Planned){
                    <div (click)="setDefaultSorting()" pTooltip="To set default sorting for Planned Tab">
                        <img src="../../../../../../assets/image/sort.svg" class="pointer-cursor default-sort-icon" />
                    </div>
                }
                <p-tabs [value]="taskInfoService.taskBankTabs.indexOf(taskInfoService.activeIndex)" (valueChange)="switchTAB($event)">
                    <p-tablist>
                        @for (tab of taskInfoService.taskBankTabs; track $index) {
                            <p-tab [value]="$index" [disabled]="tab.disabled">{{ tab.label }}</p-tab>
                        }
                    </p-tablist>
                </p-tabs>
            </div>
        </div>
        <div class="d-flex align-items-center">
            <div class=" position-relative me-2">
                @if(columnList.length && selectedTaskBankListValue) {
                    <app-column-visibility [ColumnListValue]="columnList" (handleColumnListChange)="handleColumnListChange($event)"
                        [selectedColumnListValue]="selectedTaskBankListValue">
                    </app-column-visibility>
                }
            </div>
        </div>           
    </div>
    <div class="row border py-1 px-2">
        <div class="col-12 d-flex justify-content-between px-2">
            <div class="d-flex align-items-center">
                <!-- Favorite Dropdown-->
                <div *ngIf="taskInfoService.activeIndex.label === tabName.Unplannedpickup && taskInfoService.BlFavList.length">
                    <p-select [options]="taskInfoService.BlFavList" optionLabel="name" name="selectedUnplannedFavList"
                        [(ngModel)]="taskInfoService.selectedUnplannedFavList"
                        [style]="{'width':'100px',height:'32px'}"
                        (onChange)="taskInfoService.onDropdownChange($event)">
                        <ng-template let-favList pTemplate="item">
                            <div class="flex align-items-center">
                                <div [pTooltip]="favList.blName">{{ favList.name }}</div>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                <div *ngIf="taskInfoService.activeIndex.label === tabName.PlannedPBM && taskInfoService.BlFavList.length">
                    <p-select [options]="taskInfoService.BlFavList" name="selectedPlannedFavList" optionLabel="name"
                        [(ngModel)]="taskInfoService.selectedPlannedFavList"
                        [style]="{'width':'100px',height:'32px'}"
                        (onChange)="taskInfoService.onDropdownChange($event)">
                        <ng-template let-favList pTemplate="item">
                            <div class="flex align-items-center">
                                <div [pTooltip]="favList.blName">{{ favList.name }} </div>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
            
                <!-- Task Movement Start -->
                <app-task-movement></app-task-movement>
                <!-- Task Movement End -->
  
            </div>
            <!-- Global Search -->
            <div class="d-flex align-items-center">
                <div class=" position-relative me-2">
                    <input class="form-control ms-1 py-1" (input)="filterData($event)" type="text" placeholder="Search"
                        [(ngModel)]="searchText" #searchInput="ngModel" />
                    <button *ngIf="searchText && searchText.length > 0" class="clear-icon" (click)="clearSearchAndReset()">
                        <i class="pi pi-times"></i>
                    </button>
                </div>
                @if(taskInfoService.activeIndex.label === tabName.Unplannedpickup ||
                taskInfoService.activeIndex.label === tabName.PlannedPBM){
                <div class="export-section">
                    <button
                        type="button"
                        class="pn-button pn-button-primary pn-icon-button"
                        (click)="exportPDF()"
                        pTooltip="Download in PDF"
                        tooltipPosition="left"
                        aria-label="Download in PDF">
                        <i class="pi pi-download"></i>
                    </button>
                </div>
                }
            </div>
        </div>
  
</div>
    <!-- Tabs Definations -->
    <div class="section-details" style="height: calc(100% - 108px);">
        <ng-container *ngIf="taskInfoService.activeIndex.label === tabName.Planned">
            <app-planned></app-planned>
        </ng-container>
        <ng-container *ngIf="taskInfoService.activeIndex.label === tabName.Unplannedpickup">
            <app-unplanned></app-unplanned>
        </ng-container>

        <ng-container *ngIf="taskInfoService.activeIndex.label === tabName.Unloaded">
            <app-unloaded></app-unloaded>
        </ng-container>

        <ng-container *ngIf="taskInfoService.activeIndex.label === tabName.PlannedPBM">
            <app-planned-pbm></app-planned-pbm>
        </ng-container>

        <ng-container *ngIf="taskInfoService.activeIndex.label === tabName.PushToCloud">
            <app-push-to-cloud></app-push-to-cloud>
        </ng-container>
    </div>